import { PartnerGroup } from "./partner-group";
import { Show } from "./show";
import { Episode } from "./episode";

export class PartnerGroupMappedShow {
    partnerGroup: PartnerGroup = new PartnerGroup();
    show: Show = new Show();
    episodes: Episode[] = []

    static mapProperties(item: any): PartnerGroupMappedShow {
        return {
            partnerGroup: PartnerGroup.mapProperties(item.partner_group),
            show: Show.mapProperties(item.show),
            episodes: item.episodes.map((episode: any) => Episode.mapProperties(episode))
        }
    }
}
